import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'linescape-ceo-to-speak-at-global-liner-shipping-conference',
  template: require('./linescape-ceo-to-speak-at-global-liner-shipping-conference.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-ceo-to-speak-at-global-liner-shipping-conference.scss')]
})
export class LinescapeCeoToSpeakAtGlobalLinerShippingConference extends BlogPage {
  title = "Linescape CEO to Speak at Global Liner Shipping Conference";
  description = "Linescape CEO, David Tarizzo, will give a speech entitled, “The Troubles with Sailing Schedules”, at the Global Liner Shipping Virtual Conference to be held on November 2-4, 2020.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-ceo-to-speak-at-global-liner-shipping-conference/linescape-ceo-to-speak-at-global-liner-shipping-conference.ts